import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../CommonUtils/httpBodyOptions';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const toggleAdviserClassificationType = (data: AssetBucketingDTO) => {
  return authFetch('/Adviser/AssetBucketing/ToggleAdviserClassificationType', {
    method: 'POST',
    ...httpBodyOptions(data, true),
  });
};

export const useToggleAdvisorClassificationTypeMutation = () => {
  return useMutation(toggleAdviserClassificationType);
};
